<template>
    <v-container fluid grid-list-xl class="c-container">
        <div class="c-msg-toolbar">
            <h5 class="headline c-mb-4">Alle Nachrichten</h5>
            <v-btn v-if="selectedMessages.length" @click="removeMessages" flat color="accent" outline
                   :loading="deleteProcess">
                Ausgewählte löschen
            </v-btn>
        </div>

        <v-layout row wrap fill-height>
            <v-flex xs12 xl5 class="c-mb-3">
                <div class="subheading c-mb-2">Ungehörte Nachrichten</div>
                <div class="elevation-11 c-messages">
                    <template v-if="currentDevice.voiceMessages.new.length">
                        <div class="c-messages--cnt" v-for="msg in currentDevice.voiceMessages.new"
                             v-bind:key="msg.messageId">
                            <div class="c-messages--card elevation-6">
                                <div class="c-messages--card--player">
                                    <audio controls="controls">
                                        Your browser does not support the <code>audio</code> element.
                                        <source :src="toHTTPS(msg.messageLocation)">
                                    </audio>
                                </div>
                                <div class="c-messages--card--meta">
                                    <v-checkbox hide-details class="ma-0"
                                                @change="selectMessage(msg.messageId)"></v-checkbox>
                                </div>
                            </div>
                            <div class="c-messages--label">{{ msg.startDate | niceDate}}</div>
                        </div>
                    </template>
                    <template v-else>
                         Frida hat sich alle Nachrichten von dir angehört.
                    </template>
                </div>
            </v-flex>
            <v-flex xs12 xl7>
                <div class="subheading c-mb-2">Abgehörte Nachrichten</div>
                <div class="elevation-11 c-messages">
                    <template v-if="currentDevice.voiceMessages.played.length">
                        <div class="c-messages--cnt" v-for="msg in currentDevice.voiceMessages.played"
                             v-bind:key="msg.messageId">
                            <div class="c-messages--card elevation-6">
                                <div class="c-messages--card--player">
                                    <audio controls="controls">
                                        Your browser does not support the <code>audio</code> element.
                                        <source :src="toHTTPS(msg.messageLocation)">
                                    </audio>
                                </div>
                                <div class="c-messages--card--meta">
                                    <i class="caru-icons status-good mr-2"></i>
                                    <v-avatar class="mr-5">
                                        <v-img :src="require('../../assets/avatar.jpg')"></v-img>
                                    </v-avatar>
                                    <v-checkbox hide-details class="ma-0"
                                                @change="selectMessage(msg.messageId)"></v-checkbox>
                                </div>
                            </div>
                            <div class="c-messages--playedlabel">
                                <b>Gehört am {{msg.firstEvent.created | niceDate}}</b> {{msg.startDate | niceDate}}
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <router-link :to="{name: 'voicemessage'}">Sende</router-link>
                        Frida eine Nachricht!
                    </template>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapState, mapActions} = createNamespacedHelpers('device')

export default {
  name: 'AllMessages',
  data () {
    return {
      selectedMessages: [],
      deleteProcess: false
    }
  },
  computed: {
    ...mapState({
      currentDevice: state => state.currentDevice,
    })
  },
  async created () {
    await this.getVoiceMessages()
  },
  methods: {
    toHTTPS(url){
      return url.replace('http://', 'https://')
    },
    selectMessage (messageId) {
      const i = this.selectedMessages.indexOf(messageId)
      if (i < 0) {
        this.selectedMessages.push(messageId)
      } else {
        this.selectedMessages.splice(i, 1)
      }
    },
    async removeMessages () {
      this.deleteProcess = true
      await this.removeVoiceMessages(this.selectedMessages)
      this.deleteProcess = false
      this.selectedMessages = []
    },
    ...mapActions(['getVoiceMessages', 'removeVoiceMessages'])
  }
}
</script>

<style lang="scss">
    @import "../../styles/vars";

    .c-msg-toolbar {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .c-messages {
        background-color: #fff;
        padding: 2rem;
        border-radius: $card-radius;

        &--cnt {
            margin-bottom: 2rem;

        }

        &--playedlabel {
            padding-top: 1rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }

        &--label {
            padding-top: 1rem;
            text-align: right;
        }

        &--card {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            background-color: $bg-color;

            &--player {
                flex: 1 1 auto;
                background-color: #fff;
                padding: 1rem;
                display: flex;
                z-index: 1;
                box-shadow: 11px 0 7px -4px rgba(0, 0, 0, 0.08);
            }

            &--meta {
                flex: 0 1 auto;
                padding: 1rem;
                display: flex;
                align-items: center;

                .caru-icons {
                    width: 48px;
                    height: 48px;
                }

                .v-input--selection-controls__input {
                    margin-right: 0;
                }

                .v-input--selection-controls {
                    padding-top: 0;
                }
            }
        }
    }

</style>
